import { NgModule } from '@angular/core';
import { PedidosRoutingModule } from './pedidos-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { PedidosViewComponent } from './views/pedidos-view.component';
import { PedidosListaComponent } from './components/pedidos-lista/pedidos-lista.component';
import { CrearPedidoComponent } from './components/crear-pedido/crear-pedido.component';
import { MatDialogModule } from '@angular/material/dialog';
import { DetallesDialogComponent } from './components/detalles-dialog/detalles-dialog.component';
import { EditarPedidoDialogComponent } from './components/editar-pedido-dialog/editar-pedido-dialog.component';
import { TicketPrintComponent } from './components/ticket-print/ticket-print.component';

@NgModule({
  declarations: [
    PedidosViewComponent,
    PedidosListaComponent,
    CrearPedidoComponent,
    DetallesDialogComponent,
    EditarPedidoDialogComponent,
    TicketPrintComponent,
  ],
  imports: [SharedModule, PedidosRoutingModule, MatDialogModule],
  entryComponents: [CrearPedidoComponent],
})
export class PedidosModule {}
